// extracted by mini-css-extract-plugin
export default {"button":"spacer_button__s3Ih0","primary":"spacer_primary__ThMi4","outline":"spacer_outline__3bMeg","spacer":"spacer_spacer__XqJJ9"};